var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.99 511.99",
    style: {
      enableBackground: "new 0 0 511.99 511.99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M496.35,15.627c-20.828-20.836-39.515-20.836-60.357,0L312.776,138.843l60.358,60.357L496.35,75.985 C517.194,55.15,517.194,36.462,496.35,15.627z M458.633,53.361c-4.156-4.164-4.156-10.922,0-15.086 c4.172-4.171,10.921-4.171,15.093,0c4.172,4.164,4.172,10.922,0,15.086S462.805,57.525,458.633,53.361z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E9ED"
    },
    points: "312.776,138.843 244.872,161.483 350.526,267.12 373.135,199.201 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAB2BC"
    },
    d: "M349.964,206.208c-4.156,4.164-10.922,4.164-15.094,0c-4.156-4.164-4.156-10.921,0-15.085 c4.172-4.172,10.938-4.172,15.094,0C354.136,195.287,354.136,202.044,349.964,206.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAB2BC"
    },
    d: "M320.339,176.577c-4.172,4.164-10.922,4.164-15.094,0c-4.171-4.172-4.171-10.922,0-15.094 c4.172-4.164,10.922-4.164,15.094,0C324.495,165.655,324.495,172.405,320.339,176.577z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M327.87,455.741c-74.998,74.998-196.604,74.998-271.603,0c-75.014-74.998-75.014-196.612,0-271.618 c74.998-75.006,196.604-75.006,271.603,0C402.884,259.129,402.884,380.743,327.87,455.741z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M327.87,184.123c-3.578-3.594-7.281-7.008-11.078-10.258 c64.577,75.459,61.155,189.127-10.25,260.532c-71.419,71.42-185.073,74.826-260.54,10.25c3.25,3.797,6.672,7.5,10.266,11.094 c74.998,74.998,196.604,74.998,271.603,0C402.884,380.743,402.884,259.129,327.87,184.123z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M192.077,437.304c-31.358,0-60.827-12.203-82.998-34.374s-34.374-51.64-34.374-82.998 c0-31.343,12.203-60.826,34.374-82.998c22.171-22.163,51.64-34.374,82.998-34.374c31.343,0,60.827,12.211,82.983,34.374 c22.171,22.171,34.373,51.655,34.373,82.998c0,31.358-12.202,60.827-34.373,82.998C252.903,425.1,223.419,437.304,192.077,437.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAB2BC"
    },
    d: "M282.605,229.388c-24.187-24.179-56.327-37.499-90.529-37.499l0,0l0,0 c-34.202,0-66.358,13.32-90.545,37.499c-24.187,24.187-37.499,56.342-37.499,90.544s13.312,66.358,37.499,90.545 c24.187,24.187,56.343,37.499,90.545,37.499s66.342-13.328,90.529-37.499c24.187-24.187,37.499-56.343,37.499-90.545 S306.792,253.575,282.605,229.388z M267.513,395.384c-20.141,20.155-46.937,31.248-75.436,31.248 c-28.515,0-55.295-11.093-75.451-31.248c-20.156-20.156-31.25-46.953-31.25-75.452s11.094-55.303,31.25-75.451 c20.14-20.147,46.952-31.249,75.451-31.249s55.295,11.094,75.436,31.249c20.155,20.148,31.265,46.952,31.265,75.451 S287.668,375.227,267.513,395.384z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.8960c980888667091a2962a2b5ba3ba4.svg";
export { ForwardRef as ReactComponent };